import { Button } from '@finn/design-system/atoms/button';
import { useIntl } from '@finn/ui-utils';

import { useDiscoveryConfig } from '../../core/data/MetadataProvider';

export const SUBSCRIPTION_PATH = '/subscribe';

export const ComingSoonSection = ({
  onAddToCart,
}: {
  onAddToCart: () => void;
}) => {
  const i18n = useIntl();
  const { router } = useDiscoveryConfig();

  return (
    <div className={'mt-4 w-full'}>
      <h5 className="body-16-semibold my-3">
        {i18n.formatMessage('pdp.comingSoon.beTheFirst')}
      </h5>
      <p className={'body-16-light my-3'}>
        {i18n.formatMessage('pdp.comingSoon.thisCarIsComingSoon')}
      </p>
      <div>
        <Button
          className={'w-full'}
          data-cy="browse-more"
          variant="outline"
          onClick={() => {
            router.push(SUBSCRIPTION_PATH);
          }}
        >
          {i18n.formatMessage('pdp.comingSoon.browseMoreLabel')}
        </Button>
      </div>
      <div className={'mt-3'}>
        <Button
          className={'w-full'}
          data-cy="reserve-coming-soon"
          onClick={onAddToCart}
        >
          {i18n.formatMessage('pdp.comingSoon.openPopupLabel')}
        </Button>
      </div>
    </div>
  );
};
